import { getMonthName, localizePath, t } from './i18n';
import { formatMonthUrl } from './utils/date';
import { absoluteUrl, applySocialMeta } from './seo/social-meta';

function generateQuarterSegments(year: number, isCurrentYear: boolean = false): string {
    const currentMonth = new Date().getMonth();
    let html = '';

    for (let q = 0; q <= 3; q++) {
        html += '<div class="quarter-row">';
        for (let i = q * 3; i < (q + 1) * 3; i++) {
            const monthName = getMonthName(i);
            const url = formatMonthUrl(i, year);
            const isCurrent = isCurrentYear && i === currentMonth;
            html += `<a href="${url}" class="month-link${isCurrent ? ' current-month' : ''}">${monthName}</a>`;
        }
        html += '</div>';
    }

    return html;
}

function createCustomControls(): string {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    const monthOptions = Array.from({ length: 12 }, (_, index) =>
        `<option value="${index + 1}" ${index === currentMonth ? 'selected' : ''}>${getMonthName(index)}</option>`).join('');

    return `
        <div class="custom-controls">
            <select id="month-select" class="custom-control custom-month" aria-label="${t('home.customMonth')}">${monthOptions}</select>
            <input type="number" id="year-select" class="custom-control custom-year" value="${currentYear}" min="0" aria-label="${currentYear}">
            <button type="button" id="go-custom" class="custom-go">${t('home.go')}</button>
        </div>
    `;
}

function applyHomeMeta(): void {
    const path = localizePath('/');
    applySocialMeta({
        title: t('meta.homeTitle'),
        description: t('meta.homeDescription'),
        url: absoluteUrl(path === '/' ? '/' : path),
        twitterCard: 'summary_large_image',
    });
}

function init() {
    applyHomeMeta();

    const intro = document.getElementById('home-intro');
    if (intro) {
        intro.textContent = t('home.intro');
    }

    const container = document.getElementById('month-links');
    if (!container) return;

    const now = new Date();
    const currentYear = now.getFullYear();

    const html = `
        <div class="calendar-navigation">
            <div class="year-box">
                <h2 class="year-title">${currentYear}</h2>
                ${generateQuarterSegments(currentYear, true)}
            </div>
            <div class="year-box">
                <h2 class="year-title">${currentYear + 1}</h2>
                ${generateQuarterSegments(currentYear + 1)}
            </div>
            <div class="year-box custom-box">
                <h2 class="year-title">${t('home.customMonth')}</h2>
                ${createCustomControls()}
            </div>
        </div>
    `;

    container.innerHTML = html;

    document.getElementById('go-custom')?.addEventListener('click', () => {
        const monthIndex = Number((document.getElementById('month-select') as HTMLSelectElement).value) - 1;
        const year = Number((document.getElementById('year-select') as HTMLInputElement).value);
        window.location.href = formatMonthUrl(monthIndex, year);
    });
}

document.addEventListener('DOMContentLoaded', init);
